import SummaryDetails from './SummaryDetails';

export default SummaryDetails;
